<template>
<div class="item-base">
  <div class="top">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/product' }">瑞普商城</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <product-search></product-search>
  <div class="tag">
    <div class="row" v-for="(item,index) in classify" :key="index+'s'">
      <div class="first">{{item.name}}</div>
      <div class="second"><span v-for="i in item.tagList" :key="i.id">{{i.name}}</span></div>
    </div>
  </div>
  <div class="content">
      <goods-item v-for="item in GoodData" :key="item.id" :goods-item="item"></goods-item>
  </div>
</div>
</template>

<script>

import ProductSearch from "@/views/Product/home/ProductSearch";
import GoodsItem from "@/views/Product/list/item";
export default {
  name: "ProductDetail",
  components: {GoodsItem, ProductSearch,},
  data(){
    return{
      classify:{},
      data:{},
      GoodData:{}
    }
  },
  created() {
    this.GetClassify(this.$route.params.id)
    this.data.pageNumber=0
    this.data.pageSize=1
    this.data.classifyId=this.$route.params.id
    this.GetGoodsData(this.data)
  },
  methods:{
    GetClassify(id){
      this.$axios.get('/api/productClassify/getSKUByClassifyId',{params:{
          classifyId :id
        }}).then(res=>{
        this.classify=res.data.data
      })
    },
    GetGoodsData(data){
      this.$axios.post('/api/productInfo/getProductByClassifyIdOrTagId',data).then(res=>{
        this.GoodData=res.data.data.records
      })
    }
  }
}
</script>

<style lang="less" scoped>
.item-base{
  .top{
    margin: 0 auto;
    width: 74.5%;
    padding:10px;
  }
  .tag{
    margin: 0 auto;
    width: 74.5%;
    margin-top: 15px;
    border: 1px solid #DDDDDD;
    .row{
      display: flex;
      border-bottom: 1px solid #DDDDDD;
      &:last-child{
        border-bottom: 0px;
      }
      .first{
        min-width: 7%;
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        min-height: 3.14vh;
        background: rgba(237, 239, 242, 0.5);
        padding: 5px;
      }
      .second{
        padding-left: 15px;
        span{
          width: 80px;
          display: inline-block;
          height: 12px;
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
        }
      }
    }
  }
  .content{
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    margin: 0 auto;
    width: 74.5%;
    margin-top: 15px;
  }
}
</style>